import React, { useState } from 'react';
import {
  IconButton,
  Stack,
  Text,
  Flex,
} from '@chakra-ui/react';
import { ArrowLeftIcon, ArrowRightIcon } from '@chakra-ui/icons';

type CarouselProps = {};

const Carousel: React.FC<CarouselProps> = ({ children, ...rest }) => {
  const [index, setIndex] = useState<number>(0);
  const childrenArray = React.Children.toArray(children);

  if (childrenArray.length === 0) {
    return <Text>Wrong children</Text>;
  }

  const carouselNavigation = (
    <Flex 
      justify="space-evenly" 
      alignContent="baseline" 
      width="100%" 
      mt={2} 
      mb={2}
    >
    <IconButton
      aria-label="Previous slide"
      colorScheme="messenger"
      borderRadius="full"
      onClick={() => {
        if (index <= 0) {
          return;
        }
        setIndex(index - 1);
      }}
      isDisabled={index <= 0}
      visibility={index <= 0 ? 'hidden' : 'visible'}
    >
      <ArrowLeftIcon />
    </IconButton>

    <Text aria-live="polite" aria-atomic="true">
      {index + 1}/{childrenArray.length}
    </Text>

    <IconButton
      aria-label="Next slide"
      colorScheme="messenger"
      borderRadius="full"
      onClick={() => {
        if (index >= childrenArray.length - 1) {
          return;
        }
        setIndex(index + 1);
      }}
      isDisabled={index >= childrenArray.length - 1}
      visibility={index >= childrenArray.length - 1 ? 'hidden' : 'visible'}
    >
      <ArrowRightIcon />
    </IconButton>
  </Flex>
  )

  return (
    <Stack
      position="relative"
      w="full"
      direction="column"
      justify="center"
      alignItems="center"
      gap={4}
      {...rest}
    >
      <div>{childrenArray[index]}</div>
      {carouselNavigation}
    </Stack>
  );
};

export default Carousel;
export { Carousel };
